import React from 'react'
import { storiesOf } from '@storybook/react'
import withReadme from 'storybook-readme/with-readme'

// Digital-Commons Theming
import { ThemeProvider } from 'styled-components'
import { getBaseTheme } from '../..'

// Component to surface in storybook
import Dialog from '.'
import readme from './readme.md'

// Story Setup
const stories = storiesOf('Digital-Commons/Dialog', module)

stories.addDecorator(withReadme(readme))

// Theming setup
const mode = 'refinitiv'
const baseTheme = getBaseTheme({ mode })
const builtTheme = {
  mode,
  ...baseTheme
}

class DialogDemo extends React.Component {
  state = {
    active: false
  }

  render() {
    return (
      <div>
        <button type='button' onClick={this.handleShowDialogClick}>
          Show Dialog
        </button>
        {this.state.active && (
          <Dialog type='page' active={true} onClose={this.handleDialogClose}>
            <h2>Hello, world</h2>
            <p>This is a dialog message</p>

            <div>
              <input type='text' onChange={this.handleTextChange} />
            </div>
          </Dialog>
        )}
      </div>
    )
  }

  handleShowDialogClick = () => {
    this.setState({ active: true })
  }

  handleDialogClose = () => {
    this.setState({ active: false })
  }

  handleTextChange = evt => {
    console.log(evt)
  }
}

// Stories
stories
  .add('Default', () => (
    <ThemeProvider theme={builtTheme}>
      <DialogDemo />
    </ThemeProvider>
  ))
